import { render, staticRenderFns } from "./FollowArtistCard.vue?vue&type=template&id=1d964231&scoped=true"
import script from "./FollowArtistCard.vue?vue&type=script&lang=js"
export * from "./FollowArtistCard.vue?vue&type=script&lang=js"
import style0 from "./FollowArtistCard.scss?vue&type=style&index=0&id=1d964231&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d964231",
  null
  
)

export default component.exports